import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'security-profile/settings',
    name: 'security-profile-settings',
    component: () => import('./SettingsRoot.vue'),
    children: [
      {
        path: 'products',
        name: 'security-profile-settings-products',
        components: {
          default: () => import('./ProductSettings.vue'),
          hero: () => import('./ProductSettingsHero.vue'),
        },
        meta: {
          permissions: [Permission.SuppliersAssessmentEdit],
        },
      },
      {
        path: 'third-parties',
        name: 'security-profile-settings-third-parties',
        components: {
          default: () => import('./ThirdParties.vue'),
          hero: () => import('./ThirdPartiesHero.vue'),
        },
        meta: {
          permissions: [Permission.SuppliersOwnSupplierView],
        },
      },
      {
        path: 'assets',
        name: 'security-profile-settings-assets',
        components: {
          default: () => import('@/modules/external-monitoring/AssetsPage.vue'),
          hero: () => import('@/modules/external-monitoring/AssetsHero.vue'),
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];
